module.exports = __webpack_public_path__ + "img/MDI-information-green.4427ee59.svg";